import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  address: string;
  boundingBox: {
    topRight: {
      lat: number;
      lng: number;
    };
    bottomLeft: {
      lat: number;
      lng: number;
    };
  };
  startDatetime: string;
  endDatetime: string;
  deliveryAddress?: string;
  returnAddress?: string;
  locationId?: number;
  latitude?: number;
  longitude?: number;
  models: string[];
  minDailyPrice?: number;
  maxDailyPrice?: number;
  autopilotTypes: number[];
  numSeats: number[];
  batteryRanges: number[];
};
type CarCount = number;

const fetchCarsAvailableCount = async (variables: Variables) => {
  try {
    // if (
    //   variables.address === '' ||
    //   variables.startDatetime === '' ||
    //   variables.endDatetime === ''
    // ) {
    //   return 0;
    // }

    let params: Record<string, any> = {
      start_datetime: variables.startDatetime,
      end_datetime: variables.endDatetime,
      delivery_address: variables.deliveryAddress,
      return_address: variables.returnAddress,
      location_id: variables.locationId,
      models: variables.models,
      autopilot_types: variables.autopilotTypes,
      num_seats: variables.numSeats,
      battery_ranges: variables.batteryRanges,
    };

    if (variables.address) {
      params.address = variables.address;
    }

    if (variables.latitude !== undefined && variables.longitude !== undefined) {
      params.latitude = variables.latitude;
      params.longitude = variables.longitude;
    }

    if (variables.boundingBox) {
      params.bounding_box = {
        top_right: {
          lat: variables.boundingBox.topRight.lat,
          lng: variables.boundingBox.topRight.lng,
        },
        bottom_left: {
          lat: variables.boundingBox.bottomLeft.lat,
          lng: variables.boundingBox.bottomLeft.lng,
        },
      };
    }

    if (variables.minDailyPrice !== undefined) {
      params.min_daily_price = variables.minDailyPrice;
    }

    if (variables.maxDailyPrice !== undefined) {
      params.max_daily_price = variables.maxDailyPrice;
    }

    const response = await client.post('v2/cars/available-count', params);

    return response.data.data;
  } catch (error) {
    console.error('fetchCarsAvailableCount error:', error);
    throw error;
  }
};

export const useCarsAvailableCount = createQuery<
  CarCount,
  Variables,
  AxiosError
>({
  queryKey: ['car/available-count'],
  fetcher: fetchCarsAvailableCount,
  enabled: false,
});
